<template>
  <div class="contents-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ContentsCard",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  &.-blue {
    background-color: $pale;
    > :deep(.card-header) {
      color: $blue;
    }
  }
  &.-green {
    background-color: $twilight;
    > :deep(.card-header) {
      color: $green;
    }
  }
  &.-orange {
    background-color: $success;
    > :deep(.card-header) {
      color: $orange;
    }
  }
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 60px;
  @include mq-up(md) {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }
  > :deep(.card-header) {
    text-align: center;
    padding: 10px 0;
    @include mq-up(md) {
      @include flex(flex, center, center, row, nowrap);
    }
    > .heading {
      color: $blue;
      font-size: 18px;
      line-height: 24px;
      font-weight: bold;
      @include mq-up(md) {
        font-size: 24px;
        line-height: 48px;
      }
      &.-green {
        color: $green;
      }
      &.-orange {
        color: $orange;
      }
    }
  }
  > :deep(.card-body) {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-top: 20px;
    }
  }
}
</style>
